import CalendarSVG from "@design-system/ui-icons/vanilla/Calendar"
import { createIcon } from "../createIcon"

export const CalendarIcon = createIcon(CalendarSVG)
